<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">
            <personal pageType="marriage"></personal>

            <div class="personal_right">
              <h2  class="tit8 "><span><img src="../../../static/images/guide_sign4.png"> 我的预约列表</span></h2>
              <template>
                <el-tabs style="padding-left: 30px" v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane  label="婚登预约" name="first">
                    <div style="padding-left: 20px;">未找到预约信息？<a href="javascript:void(0)" style="color:blue;" @click="detailSelfClick()">点击这里手动查看预约结果</a></div>
                    <div style="width: 100%;" v-if="marriageList &&  marriageList.length>0">
                      <el-card class="box-card" shadow="hover"
                               style="width: 96%;margin-left: 20px;margin-top: 10px;font-size: 14px;"
                               v-for="(item,index) in marriageList" :key="index"

                      >
                        <div  @click="showDetail(item)">
                          <div slot="header" class="clearfix">
                  <span>
                       <el-tag v-if="item.applyStatus=='3'"
                               type="warning"
                               effect="dark" style="width: 80px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    已登记
                  </el-tag>
                       <el-tag  v-if="item.applyStatus=='10'"
                                effect="dark" style="width: 80px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    受理中
                  </el-tag>
                    <el-tag  v-if="item.applyStatus=='20'"
                             type="success"
                             effect="dark" style="width: 80px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    预约成功
                  </el-tag>
                    <el-tag  v-if="item.applyStatus=='30'"
                             type="info"
                             effect="dark" style="width: 80px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    预约失败
                  </el-tag>
                    <el-tag  v-if="item.applyStatus=='40'"
                             type="info"
                             effect="dark" style="width: 80px;height: 20px;line-height: 20px;margin-right: 5px;margin-top: 2px;font-size: 12px">
                    已撤销
                  </el-tag>
                    <span style="font-weight: 600">{{item.deptName}}</span>
                      </span>
                          </div>
                          <div class="text item" style="line-height: 23px;margin-top: 10px;" >
                            <div style="display: flex;justify-content: left;">
                              <div style="width:300px;"><span class="yy_title">业务类型：</span><span class="yy_title_content">{{item.opTypeName}}</span></div>
                              <div><span class="yy_title">预约日期：</span><span class="yy_title_content">{{item.bookDate}}</span></div>
                            </div>
                            <div style="display: flex;justify-content: left;">
                              <div style="width:300px;"><span class="yy_title">男方姓名：</span><span class="yy_title_content">{{item.nameMan}}</span></div>
                              <div><span class="yy_title">女方姓名：</span><span class="yy_title_content">{{item.nameWoman}}</span></div>
                            </div>
                            <!--   <div style="float: left;padding-bottom: 20px;padding-top: 10px;margin-right: 5px">
                                 <el-button  type="primary" style=" padding: 5px;font-size: 12px;" ">预约详情</el-button>
                                </div>-->

                          </div>
                        </div>

                      </el-card>
                    </div>
                    <div v-else>
                      <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                        <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                        <div>暂无数据</div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="丧报预约" name="second">
                    <div style="width: 100%;" v-if="funeralList &&  funeralList.length>0">
                      <el-card class="box-card" shadow="hover"
                               style="width: 96%;margin-left: 20px;margin-top: 10px;font-size: 14px;"
                               v-for="(item,index) in funeralList" :key="index"
                      >
                        <div  @click="showOrgainfoDetail(item,'second')">
                          <div slot="header" class="clearfix">
                  <span>
                    <span style="font-weight: 600">{{item.organName}}</span>
                      </span>
                          </div>
                          <div class="text item" style="line-height: 23px;" >
                            <div style="display: flex;justify-content: left;">
                              <div style="width:300px;"><span class="yy_title">联系人：</span><span class="yy_title_content">{{item.reqName}}</span></div>
                              <div><span class="yy_title">联系电话：</span><span class="yy_title_content">{{item.mobilePhone}}</span></div>
                            </div>
                            <div style="display: flex;justify-content: left;">
                              <div style="width:300px;"><span class="yy_title">预约日期：</span><span class="yy_title_content">{{item.yyDate}}</span></div>
                              <div><span class="yy_title">提交时间：</span><span class="yy_title_content">{{item.createTime}}</span></div>
                            </div>
                            <!--   <div style="float: left;padding-bottom: 20px;padding-top: 10px;margin-right: 5px">
                                 <el-button  type="primary" style=" padding: 5px;font-size: 12px;" ">预约详情</el-button>
                                </div>-->

                          </div>
                        </div>

                      </el-card>
                    </div>
                    <div v-else>
                      <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                        <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                        <div>暂无数据</div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="骨灰寄存预约"   name="third">
                    <div style="width: 100%;" v-if="ashesList &&  ashesList.length>0" >
                      <el-card class="box-card" shadow="hover"
                               style="width: 96%;margin-left: 20px;margin-top: 10px;font-size: 14px;"
                               v-for="(item,index) in ashesList" :key="index"
                      >
                        <div  @click="showOrgainfoDetail(item,'third')">
                          <div slot="header" class="clearfix">
                  <span>
                    <span style="font-weight: 600">{{item.organName}}</span>
                      </span>
                          </div>
                          <div class="text item" style="line-height: 23px;" >
                            <div style="display: flex;justify-content: left;">
                              <div style="width:300px;"><span class="yy_title">联系人：</span><span class="yy_title_content">{{item.reqName}}</span></div>
                              <div><span class="yy_title">联系电话：</span><span class="yy_title_content">{{item.mobilePhone}}</span></div>
                            </div>
                            <div style="display: flex;justify-content: left;">
                              <div style="width:300px;"><span class="yy_title">预约日期：</span><span class="yy_title_content">{{item.receiveDate}}</span></div>
                              <div><span class="yy_title">提交时间：</span><span class="yy_title_content">{{item.createTime}}</span></div>
                            </div>
                            <!--   <div style="float: left;padding-bottom: 20px;padding-top: 10px;margin-right: 5px">
                                 <el-button  type="primary" style=" padding: 5px;font-size: 12px;" ">预约详情</el-button>
                                </div>-->

                          </div>
                        </div>

                      </el-card>
                    </div>
                    <div v-else>
                      <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                        <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                        <div>暂无数据</div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="墓位预定预约" name="fourth">
                    <div style="width: 100%;" v-if="cemeteryList &&  cemeteryList.length>0">
                      <el-card class="box-card" shadow="hover"
                               style="width: 96%;margin-left: 20px;margin-top: 10px;font-size: 14px;"
                               v-for="(item,index) in cemeteryList" :key="index"
                      >
                        <div  @click="showOrgainfoDetail(item,'fourth')">
                          <div slot="header" class="clearfix">
                  <span>
                    <span style="font-weight: 600">{{item.organName}}</span>
                      </span>
                          </div>
                          <div class="text item" style="line-height: 23px;" >
                            <div style="display: flex;justify-content: left;">
                              <div style="width:300px;"><span class="yy_title">联系人：</span><span class="yy_title_content">{{item.reqName}}</span></div>
                              <div><span class="yy_title">联系电话：</span><span class="yy_title_content">{{item.mobilePhone}}</span></div>
                            </div>
                            <div style="display: flex;justify-content: left;">
                              <div style="width:300px;"><span class="yy_title">预约日期：</span><span class="yy_title_content">{{item.receiveDate}}</span></div>
                              <div><span class="yy_title">提交时间：</span><span class="yy_title_content">{{item.createTime}}</span></div>
                            </div>
                            <!--   <div style="float: left;padding-bottom: 20px;padding-top: 10px;margin-right: 5px">
                                 <el-button  type="primary" style=" padding: 5px;font-size: 12px;" ">预约详情</el-button>
                                </div>-->

                          </div>
                        </div>

                      </el-card>
                    </div>
                    <div v-else>
                      <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                        <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                        <div>暂无数据</div>
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </template>

              <div style="width: 100%;height: 50px;">&nbsp;</div>
              <div class="clear"></div>
              <!--手动查看预约信息--->
              <el-dialog  :visible.sync="detailSelfShow" width="900px" title="请输入双方证件号码，查询预约信息">
                    <div>
                      男方证件号码： <el-input v-model="certNumMan" maxlength="20" placeholder="请输入..."  style="width: 210px;"></el-input>
                      &nbsp; &nbsp;女方证件号码：  <el-input v-model="certNumWoman" maxlength="20" placeholder="请输入..."  style="width: 210px;"></el-input>
                      <el-button   type="primary" @click="checkMarrayData()" style=" width: 80px; margin-left: 10px;" >查询</el-button>
                    </div>
                    <div style="width: 100%;height: 20px;border-bottom: 1px solid #e3dede;"></div>
                    <div v-if="marraySelfData">
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;"  >
                        <tr>
                          <td width="18%" class="grey">预约编号</td>
                          <td width="32%">{{marraySelfData.bookId}}</td>
                          <td width="18%" class="grey">预约日期</td>
                          <td width="32%">{{marraySelfData.bookDateInfo}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">登记处名称</td>
                          <td width="32%">{{marraySelfData.deptName}}</td>
                          <td width="18%" class="grey">登记处地址</td>
                          <td width="32%">{{marraySelfData.deptAddress}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">预约详细</td>
                          <td  colspan="3">{{marraySelfData.bookMessage}}</td>
                        </tr>
                      </table>
                      <td colspan="2"  ><h2 class="information_tit">双方信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;" >
                        <tr>
                          <td width="18%" class="grey">男方姓名</td>
                          <td width="32%">{{marraySelfData.nameMan}}</td>
                          <td width="18%" class="grey">女方姓名</td>
                          <td width="32%">{{marraySelfData.nameWoman}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">男方身份证号码</td>
                          <td width="32%">{{marraySelfData.certNumMan}}</td>
                          <td width="18%" class="grey">女方身份证号码</td>
                          <td width="32%">{{marraySelfData.certNumWoman}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">男方联系方式</td>
                          <td width="32%">{{marraySelfData.manTel}}</td>
                          <td width="18%" class="grey">女方联系方式</td>
                          <td width="32%">{{marraySelfData.womanTel}}</td>
                        </tr>
                      </table >
                      <div style="width: 120px;margin: 0 auto;line-height: 50px;" v-if="marraySelfData.canCal && marraySelfData.canCal == 'yes'" >   <el-button type="primary" @click="calMarray(marraySelfData.certNumMan,marraySelfData.certNumWoman)" >取消预约</el-button></div>
                    </div>
                    <div v-else style="height: 300px;line-height: 300px;text-align: center">
                      暂无预约详细
                    </div>

              </el-dialog>
              <!--婚登-->
              <el-dialog  :visible.sync="detailShow" width="900px" >
                <div>
                  <a style="font-weight: 800">预约业务：</a><a>{{data.opTypeName}}</a>
                </div>
                <template>
                  <el-tabs v-model="activeName3" type="border-card" @tab-click="handleClick">
                    <el-tab-pane  label="预约详情"  name="first">
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;" v-if="hdSussessData!=null">
                        <tr>
                          <td width="18%" class="grey">预约编号</td>
                          <td width="32%">{{hdSussessData.bookId}}</td>
                          <td width="18%" class="grey">预约日期</td>
                          <td width="32%">{{hdSussessData.bookDate}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">预约时间详情</td>
                          <td width="32%">{{hdSussessData.bookDateInfo}}</td>
                          <td width="18%" class="grey">登记处名称</td>
                          <td width="32%">{{hdSussessData.deptName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">登记处地址</td>
                          <td width="32%">{{hdSussessData.deptAddress}}</td>
                          <td width="18%" class="grey">预约详细</td>
                          <td width="32%">{{hdSussessData.bookMessage}}</td>
                        </tr>
                      </table>
                      <table v-else>
                        <tr><td style="text-align: center">暂无预约详细</td></tr>
                      </table>

                      <td colspan="2" v-if="hdSussessData!=null"><h2 class="information_tit">双方信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;" v-if="hdSussessData!=null">
                        <tr>
                          <td width="18%" class="grey">男方姓名</td>
                          <td width="32%">{{hdSussessData.nameMan}}</td>
                          <td width="18%" class="grey">女方姓名</td>
                          <td width="32%">{{hdSussessData.nameWoman}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">男方身份证号码</td>
                          <td width="32%">{{hdSussessData.certNumMan}}</td>
                          <td width="18%" class="grey">女方身份证号码</td>
                          <td width="32%">{{hdSussessData.certNumWoman}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">男方联系方式</td>
                          <td width="32%">{{hdSussessData.manTel}}</td>
                          <td width="18%" class="grey">女方联系方式</td>
                          <td width="32%">{{hdSussessData.womanTel}}</td>
                        </tr>
                      </table >
                      <div style="width: 120px;margin: 0 auto;line-height: 50px;" v-if="hdSussessData && hdSussessData.canCal=='yes'">   <el-button type="primary" @click="calMarray(hdSussessData.certNumMan,hdSussessData.certNumWoman)" >取消预约</el-button></div>
                    </el-tab-pane>
                    <el-tab-pane  label="预约概要"  name="two">
                      <td colspan="2"><h2 class="information_tit">其它信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="18%" class="grey">业务类型</td>
                          <td width="32%">{{data.opTypeName}}</td>
                          <td width="18%" class="grey">登记处名称</td>
                          <td width="32%">{{data.deptName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">预约日期</td>
                          <td width="32%">{{data.bookDate}}</td>
                          <td width="18%" class="grey">预约时间段</td>
                          <td width="32%">{{data.startTime}}--{{data.endTime}}</td>
                        </tr>
                        <tr v-if="data.oldOpDate!=''||data.oldDeptName!=''">
                          <td v-if="data.oldOpDate!=''" width="18%" class="grey">原登记日期</td>
                          <td v-if="data.oldOpDate!=''" width="32%">{{data.oldOpDate}}</td>
                          <td v-if="data.oldDeptName!=''" width="18%" class="grey">原登记机关名称</td>
                          <td v-if="data.oldDeptName!=''" width="32%">{{data.oldDeptName}}</td>
                        </tr>
                        <tr v-if="data.oldCertNo!=''||data.divorceReasonName!=''">
                          <td v-if="data.oldCertNo!=''" width="18%" class="grey">原登记字号</td>
                          <td v-if="data.oldCertNo!=''" width="32%">{{data.oldCertNo}}</td>
                          <td v-if="data.divorceReasonName!=''&& data.divorceReasonName!=null" width="18%" class="grey">离婚原因</td>
                          <td v-if="data.divorceReasonName!=''&& data.divorceReasonName!=null" width="32%">{{data.divorceReasonName}}</td>
                        </tr>
                      </table>
                      <td colspan="2"><h2 class="information_tit">男方信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="18%" class="grey">男方姓名</td>
                          <td width="32%">{{data.nameMan}}</td>
                          <td width="18%" class="grey">男方身份类别</td>
                          <td width="32%">{{data.idTypeManName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">男方证件类型</td>
                          <td width="32%">{{data.certTypeManName}}</td>
                          <td width="18%" class="grey">男方身份证件号</td>
                          <td width="32%">{{data.certNumMan}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">男方出生日期</td>
                          <td width="32%">{{data.birthMan}}</td>
                          <td width="18%" class="grey">男方民族</td>
                          <td width="32%">{{data.folkManName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">男方婚姻状况</td>
                          <td width="32%">{{data.marryStatusManName}}</td>
                          <td width="18%" class="grey">男方职业</td>
                          <td width="32%">{{data.jobManName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">男方文化程度</td>
                          <td width="32%">{{data.degreeManName}}</td>
                          <td width="18%" class="grey">男方常住户口</td>
                          <td width="32%">{{data.regSjManName+data.regDsManName+data.regQxManName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">男方常住户口所在地</td>
                          <td width="32%">{{data.regDetailMan}}</td>
                          <td width="18%" class="grey">联系方式（男）</td>
                          <td width="32%">{{data.mobile}}</td>
                        </tr>
                      </table>
                      <td colspan="2"><h2 class="information_tit">女方信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="18%" class="grey">女方姓名</td>
                          <td width="32%">{{data.nameWoman}}</td>
                          <td width="18%" class="grey">女方身份类别</td>
                          <td width="32%">{{data.idTypeWomanName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">女方证件类型</td>
                          <td width="32%">{{data.certTypeWomanName}}</td>
                          <td width="18%" class="grey">女方身份证件号</td>
                          <td width="32%">{{data.certNumWoman}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">女方出生日期</td>
                          <td width="32%">{{data.birthWoman}}</td>
                          <td width="18%" class="grey">女方民族</td>
                          <td width="32%">{{data.folkWomanName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">女方婚姻状况</td>
                          <td width="32%">{{data.marryStatusWomanName}}</td>
                          <td width="18%" class="grey">女方职业</td>
                          <td width="32%">{{data.jobWomanName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">女方文化程度</td>
                          <td width="32%">{{data.degreeWomanName}}</td>
                          <td width="18%" class="grey">女方常住户口</td>
                          <td width="32%">{{data.regSjWomanName+data.regDsWomanName+data.regQxWomanName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">女方常住户口所在地</td>
                          <td width="32%">{{data.regDetailWoman}}</td>
                          <td width="18%" class="grey">联系方式（女）</td>
                          <td width="32%">{{data.tel}}</td>
                        </tr>
                      </table>
                    </el-tab-pane>

                    <el-tab-pane label="预约材料" name="third">
                      <td colspan="2"><h2 class="information_tit">上传图片一览</h2></td>

                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">

                        <tr><td>
                          <div   v-for="(photo,index) in data.attachList" v-if="photo.attachId && photo.attachId!='-1'" :key="index+'fjfj'">
                            <div v-if="!(data.apply_way =='0' && photo.oneTypeCode=='FJ_1_ATTORNEY')" style="width: 100%">
                              <div style="line-height: 27px;margin-bottom: 5px ;font-size: 14px;padding-left: 5px;    font-weight: 600;
      background-color: #f2f3f5;">» {{photo.docName}}</div>
                              <div >

                                <div style="width:100%;text-align: right;" >
                                  <img   :src="getImg(photo.attachId)" style="width: 180px;height: 150px;" />

                                </div>
                              </div>
                            </div>
                            <!--</el-form-item>-->
                          </div>
                        </td></tr>
                      </table>
                    </el-tab-pane>
                  </el-tabs>
                </template>
              </el-dialog>
              <!--殡葬-->
              <el-dialog  :visible.sync="orgainfodetailShow" width="900px" >
                <template>
                  <el-tabs v-model="activeName3" type="border-card" @tab-click="handleClick">

                    <el-tab-pane  label="预约概要"  name="first">
                      <td colspan="2"><h2 class="information_tit">其它信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="18%" class="grey">预约单位</td>
                          <td width="32%">{{data.organName}}</td>
                          <td width="18%" class="grey">预约日期</td>
                          <td width="32%" v-if="code=='second'">{{data.yyDate}}</td>
                          <td width="32%" v-else>{{data.receiveDate}}</td>
                        </tr>
                        <tr  v-if="code=='second'">
                          <td width="18%" class="grey">接运地址</td>
                          <td width="32%">{{data.address}}</td>
                          <td width="18%" class="grey"></td>
                          <td width="32%"></td>
                        </tr>

                      </table>
                      <td colspan="2"><h2 class="information_tit">逝者信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="18%" class="grey">逝者姓名</td>
                          <td width="32%">{{data.name}}</td>
                          <td width="18%" class="grey">证件类型</td>
                          <td width="32%">{{data.cardTypeName}}</td>
                        </tr>
                        <tr  v-if="code=='second'">
                          <td width="18%" class="grey">逝者证件号码</td>
                          <td width="32%">{{data.idCard}}</td>
                          <td width="18%" class="grey">去世时间</td>
                          <td width="32%">{{data.deathDate}}</td>
                        </tr>
                        <tr v-else>
                          <td width="18%" class="grey">逝者证件号码</td>
                          <td width="32%">{{data.idCard}}</td>
                          <td width="18%" class="grey">火化时间</td>
                          <td width="32%">{{data.cremationTime}}</td>
                        </tr>
                        <tr v-if="code=='second'">
                          <td width="18%"  class="grey">去世原因</td>
                          <td width="32%">{{data.deathCause}}</td>
                          <td width="18%" class="grey"></td>
                          <td width="32%"></td>
                        </tr>
                        <tr v-else>
                          <td width="18%"  class="grey">火化地点</td>
                          <td width="32%">{{data.cremationPlace}}</td>
                          <td width="18%" class="grey"></td>
                          <td width="32%"></td>
                        </tr>

                      </table>
                      <td colspan="2"><h2 class="information_tit">家属信息</h2></td>
                      <table width="100%" border="0" cellspacing="1" cellpadding="0" class="details_tab" style="margin: 15px auto;">
                        <tr>
                          <td width="18%" class="grey">家属姓名</td>
                          <td width="32%">{{data.reqName}}</td>
                          <td width="18%" class="grey">证件类型</td>
                          <td width="32%">{{data.reqCardTypeName}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">家属证件号码</td>
                          <td width="32%">{{data.reqIdCard}}</td>
                          <td width="18%" class="grey">联系电话</td>
                          <td width="32%">{{data.mobilePhone}}</td>
                        </tr>
                        <tr>
                          <td width="18%" class="grey">与逝者关系</td>
                          <td width="32%">{{data.relation}}</td>
                          <td width="18%" class="grey"></td>
                          <td width="32%"></td>
                        </tr>

                      </table>
                    </el-tab-pane>
                  </el-tabs>
                </template>
              </el-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import personal from "../../components/Personal";
  export default {
    name: "Consulting",
    components: {
      headers, fixedDiv, footers,personal
    },
    watch:{

    },
    data(){
      return{
        consulting_list:[],
        funeralList:[],
        ashesList:[],
        cemeteryList:[],
        marriageList:[],
        orgainifList:[],
        loginShow:false,
        orgainfodetailShow:false,
        detailShow:false,
        gotoIndex:false,
        marriageShow:true,
        organinfoShow:false,
        tabName:'婚登预约',
        typeId:0,
        code:'',
        activeName3: 'first',
        activeName: 'first',
        data: {},
          hdSussessData:null,
          detailSelfShow:false,
          certNumMan:'',
          certNumWoman:'',
          marraySelfData:null,
      }
    },
    created(){



    },
    mounted() {
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
      }
      this.getListData();
     /* 丧报预约*/
      this.getFuneralListData();
      /*骨灰寄存预约*/
      this.getAshesListData();
      /*墓位预定预约*/
      this.getCemeteryListData();
    },
    methods:{
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      } ,
      getImg(imgId){
        var dd=this.$util.req.getshowImg(imgId);
        return dd;
      },
      showDetail( item){
          this.data={},
          this.onMarrayInfo(item.billId,item.marryId,'');
          this.data=item;
          this.detailShow=true;
      },
      showOrgainfoDetail(item,code){
          this.code=code;
          this.data={},
            this.orgainfodetailShow=true;
          this.data=item;
      },
      handleClick(tab, event){

      },
      marriageShowClick(){
        this.marriageShow=true;
        this.organinfoShow=false;
      },
      organinfoShowClick(){
        this.marriageShow=false;
        this.organinfoShow=true;
      },
      getListData() {
        var tt = this;
        this.$https.post("api/marriage/reservationQuery.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.marriageList=response.data.data;
          } else {
            // this.$router.push({path:'/peopleLogin'});
          }
        });
      },
      /*骨灰寄存预约*/
      getAshesListData() {
        var tt = this;
        this.$https.post("api/funeral/selEmplaceReceive.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.ashesList=response.data.data;
          } else {
            // this.$router.push({path:'/peopleLogin'});
          }
        });
      },
      /*墓位预定预约*/
      getCemeteryListData() {
        var tt = this;
        this.$https.post("api/funeral/selCemeReceive.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.cemeteryList=response.data.data;
          } else {
            // this.$router.push({path:'/peopleLogin'});
          }
        });
      },
      /* 丧报预约*/
      getFuneralListData() {
        var tt = this;
        this.$https.post("api/funeral/selReceive.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            this.funeralList=response.data.data;
          } else {
            // this.$router.push({path:'/peopleLogin'});
          }
        });
      },
        onMarrayInfo(billId,marrayId,marrayTypeName){
            this.marrayTypeName=marrayTypeName;
            let tt = this;
            this.$https.post("api/marriage/queryBookMarryInfoByMarrayId.do", {billId:billId,marrayId:marrayId}, response => {
                if (response.status === 200 && response.data.code === 200 && response.data.data) {
                    tt.hdSussessData = response.data.data;
                    tt.hdyysuccShow=true;
                }else{
                    Dialog.alert({
                        message: "数据获取失败，请稍后重试",
                    }).then(() => {
                        tt.hdyysuccShow=false
                    });
                }
            })
            ;
        },
        calMarray(manIdcard,womanIdcard){
            this.detailShow=false;
            this.detailSelfShow=false;
            var t=this;
            this.$dialog.confirm({title:'提示',message:'确认要取消本次预约吗?',confirmButtonColor:'red'})
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '数据处理中,请耐心等待....',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    const options={
                        certNumMan:manIdcard,
                        certNumWoman:womanIdcard,
                    };
                    t.$https.post("/api/marriage/bookCancel.do",options,response=> {
                        loading.close();
                        if (response.status === 200 && response.data.code === 200) {
                            t.$dialog.alert({
                                message: "预约取消成功",
                            }).then(() => {
                                t.getListData();
                                t.detailShow=false;
                                t.detailSelfShow=false;
                            });
                        }else {
                            t.$dialog.alert({
                                message: "数据异常，请稍后重试",
                            }).then(() => {
                                // tt.hdyysuccShow=false
                            });
                        }
                    })
                })
                .catch(() => {
                });
        },
        detailSelfClick(){
          this.detailSelfShow=true
        },
        checkMarrayData(){
          var t=this;
          if(this.certNumMan==''){
              t.$dialog.alert({
                  message: "请输入男方证件号码",
              }).then(() => {
              });
              return false;
          }
            if(this.certNumWoman==''){
                t.$dialog.alert({
                    message: "请输入女方证件号码",
                }).then(() => {
                });
                return false;
            }
            var loading = this.$loading({
                lock: true,
                text: '数据查询中,请耐心等待....',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$https.post("/api/marriage/queryBookMarryInfo.do",{certNumMan:this.certNumMan,certNumWoman:this.certNumWoman},response=> {
                loading.close();
                if (response.status === 200 && response.data.code === 200) {
                    if(response.data.data){
                       t.marraySelfData= response.data.data;
                    }else{
                        t.marraySelfData=null;
                        t.$dialog.alert({
                            message: "暂无预约信息，请确认双方证件号码正确！",
                        }).then(() => {
                            // tt.hdyysuccShow=false
                        });
                    }
                }else {
                    t.$dialog.alert({
                        message: "数据异常，请稍后重试",
                    }).then(() => {
                        // tt.hdyysuccShow=false
                    });
                }
            })
        }
    }
  }
</script>

<style>
  .personal_right .el-card__header {
    padding: 9px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #f7f7f7;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personal/Marriage.vue